import React from 'react';
import { Container } from '@philips-internal/oswald-ui-core';
import { SuppressHeadingMarginProperties } from './suppress-heading-margin-types.js';
import './suppress-heading-margin.css';
const SuppressHeadingMarginContainer = {
    name: '',
};
function getStyleObject(props) {
    const style = {};
    if (props.applyLeftPadding ?? SuppressHeadingMarginProperties.applyLeftPadding.defaultValue) {
        style.paddingLeft = 'var(--tws-heading-vertical-spacing)';
    }
    if (props.applyRightPadding ?? SuppressHeadingMarginProperties.applyRightPadding.defaultValue) {
        style.paddingRight = 'var(--tws-heading-vertical-spacing)';
    }
    return style;
}
function SuppressHeadingMargin(props) {
    const style = getStyleObject(props);
    return (React.createElement(Container, { className: "c-suppress-heading-margin", style: style, uuid: props.uuid ?? SuppressHeadingMarginProperties.uuid.defaultValue }, props.children));
}
export { SuppressHeadingMargin, SuppressHeadingMarginContainer, };
//# sourceMappingURL=suppress-heading-margin.js.map